import { bannersConstants } from "../constants/bannersConstants";
import { bannersService } from "../../services/API/bannersService";
import { history } from "../store/configureStore";

export const bannersActions = {
  getBannersData,
  getBannersList,
  deleteBanners,
  getBannersDetails,
  getSiteList
};

function getBannersData() {
  return dispatch => {
    dispatch(request());
    bannersService.getBannersList().then(
      banners => {
        dispatch(success(banners));
      },
      error => {
        dispatch(failure("getBannersData error: " + error.toString()));
      }
    );
  };

  function request(banners) {
    return { type: bannersConstants.FETCH_BANNERS_REQUEST, banners };
  }
  function success(banners) {
    return { type: bannersConstants.FETCH_BANNERS_SUCCESS, banners };
  }
  function failure(error) {
    return { type: bannersConstants.FETCH_BANNERS_FAILURE, error };
  }
}

export const addBanners = postData => {
  return dispatch => {
    dispatch(request());
    bannersService.addBanners(postData).then(
      banners => {
        dispatch(success(banners));
        history.push("/banners");
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(banners) {
    return { type: bannersConstants.ADD_BANNERS_REQUEST, banners };
  }
  function success(banners) {
    return { type: bannersConstants.ADD_BANNERS_SUCCESS, banners };
  }
  function failure(error) {
    return { type: bannersConstants.ADD_BANNERS_FAILURE, error };
  }
};

export const getBannersList = formData => {
  return dispatch => {
    dispatch(request());
    bannersService.getBannersList(formData).then(
      banners => {
        dispatch(success(banners));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(banners) {
    return { type: bannersConstants.FETCH_BANNERS_REQUEST, banners };
  }
  function success(banners) {
    return { type: bannersConstants.FETCH_BANNERS_SUCCESS, banners };
  }
  function failure(error) {
    return { type: bannersConstants.FETCH_BANNERS_FAILURE, error };
  }
};

export const deleteBanners = bannersIdASParams => {
  return dispatch => {
    dispatch(request());
    bannersService.deleteBanners(bannersIdASParams).then(
      banners => {
        dispatch(success(banners));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(banners) {
    return { type: bannersConstants.DELETE_BANNERS_REQUEST, banners };
  }
  function success(banners) {
    return { type: bannersConstants.DELETE_BANNERS_SUCCESS, banners };
  }
  function failure(error) {
    return { type: bannersConstants.DELETE_BANNERS_FAILURE, error };
  }
};

export const getBannersDetails = bannersIdParams => {
  return dispatch => {
    dispatch(request());
    bannersService.getBannersDetails(bannersIdParams).then(
      bannersDetails => {
        dispatch(success(bannersDetails));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(bannersDetails) {
    return { type: bannersConstants.GET_BANNERS_DETAILS_REQUEST, bannersDetails };
  }
  function success(bannersDetails) {
    return { type: bannersConstants.GET_BANNERS_DETAILS_SUCCESS, bannersDetails };
  }
  function failure(error) {
    return { type: bannersConstants.GET_BANNERS_DETAILS_FAILURE, error };
  }
};

export const updateBanners = postData => {
  return dispatch => {
    dispatch(request());
    bannersService.updateBanners(postData).then(
      updatedBanners => {
        dispatch(success(updatedBanners));
        history.push("/banners");
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(updatedBanners) {
    return { type: bannersConstants.UPDATE_BANNERS_REQUEST, updatedBanners};
  }
  function success(updatedBanners) {
    return { type: bannersConstants.UPDATE_BANNERS_SUCCESS, updatedBanners };
  }
  function failure(error) {
    return { type: bannersConstants.UPDATE_BANNERS_FAILURE, error };
  }
};

export const getSiteList = (page) => {
  return dispatch => {
    dispatch(request());
    bannersService.get_SiteList(page).then(
      sitelist => {
        dispatch(success(sitelist));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(sitelist) {
    return { type: bannersConstants.FETCH_SITELIST_REQUEST, sitelist };
  }
  function success(sitelist) {
    return { type: bannersConstants.FETCH_SITELIST_SUCCESS, sitelist };
  }
  function failure(error) {
    return { type: bannersConstants.FETCH_SITELIST_FAILURE, error };
  }
};


// WEBPACK FOOTER //
// ./src/app/redux/actions/bannersActions.js